import * as _ from 'underscore';
import * as $ from "jquery";
import * as Marionette from 'backbone.marionette';
import {config} from '../config/detector-config';
import getGalleryConfig from '../config/gallery-config';
import 'jquery-match-height';
import 'picturefill';
import 'picturefill/dist/plugins/mutation/pf.mutation.min';
import 'select2';
import 'lity';
import 'url-polyfill';
import '../vendor/bg-video-player';
import '../vendor/social';
import '../vendor/nfscroll';
import '../vendor/aos';
import '../vendor/link-checker';

export default class Detector extends Marionette.Object {

    get config():any {
        return config;
    }

    constructor(options?:object) {
        super(options);
    }

    findEls(selector: string) {
        return $(this.config.context).find(selector);
    }

    isDetected(el: any) {
        return el.length !== 0;
    }

    detect() {
        for (let view of this.config.views) {
            let els = this.findEls(view.selector);
            if (this.isDetected(els)) {
                _.each(els, el => { this.initView(view, el) });
            }
        }
        this.initPhatPlayer();
        this.initMatchHeight();
        this.initSelect2();
        this.initDisablePopupLinks();
        this.initAmendMobileLinks();
    }

    initView(view: any, el: any) {
        const type = el.getAttribute('data-js-view-type');
        const config = type ? getGalleryConfig(type) : {};
        view.getView({el}, config).render();
    }

    initPhatPlayer() {
        const $phat = $("[data-js-ui=phat-player]");
        if ($phat.length) {
            $phat.each((index: number, el: any) => {
                var w = window.innerWidth;
                var $element = (<any>$(el));
                if(w > 1024) {
                    $element.attr('data-phatposter', $element.attr('data-phatposter'));
                }
                else if (w > 504 && $element.attr('data-phatlandscape')) {
                    $element.attr('data-phatposter', $element.attr('data-phatlandscape'));
                }
                else if (w < 504 && $element.attr('data-phatmobile')) {
                    $element.attr('data-phatposter', $element.attr('data-phatmobile'));
                }
                $element.phatVideoBg();
            });
        }
    }

    initMatchHeight() {
        const matches = $(this.config.matchSelector);
        matches.matchHeight();
    }

    initSelect2() {
        const select = $(this.config.selectBoxSelector);
        if (select.length) {
            select.each((index: number, el: any) => {
                let placeholder = (<any>$(el)).data('selectPlaceholder') || "";
                (<any>$(el)).select2({
                    dropdownAutoWidth: true,
                    minimumResultsForSearch: Infinity,
                    placeholder: placeholder,
                    allowClear: true,
                });
            });
        }
    }

    initDisablePopupLinks() {
        const links = document.querySelectorAll(this.config.disabledLinkSelector);

        [].forEach.call(links, function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault();
            }, false);
        });
    }

    initAmendMobileLinks() {
        if (window.location.href.indexOf('mobile_webview') === -1) {
            return;
        }

        const absoluteLinks = document.querySelectorAll('a[href*="' + top.location.host.toString() + '"]');
        const relativeLinks = document.querySelectorAll('a[href^="/"]');

        const update = (link:any) => {
            let href = link.getAttribute('href');

            if (!href) {
                return;
            }

            if (href === '/') {
                href = top.location.origin;
            }

            if (href.indexOf('/') === 0) {
                href = top.location.origin + href;
            }

            const url = new URL(href);

            url.searchParams.append('mobile_webview', 'true');

            link.setAttribute('href', url.toString());
        }

        [].forEach.call(absoluteLinks, update);

        [].forEach.call(relativeLinks, update);
    }
}



// WEBPACK FOOTER //
// ./@modules/utils/detector.ts